import { PhoneIcon } from './PhoneIcon';

/**
 * author: Google
 * id B5BA809F-FCE8-476C-8388-6A9CFFF73015
 * name phone
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/phone.svg
 * tags
 * - Cellphone / Phone 
 */
export const TelephoneIcon = PhoneIcon;
export default TelephoneIcon